import ShopOrderItemListResultModelBase from '../_generated/modelBases/shop-order-item-list-result-model-base';

export default class ShopOrderItemListResultModel extends ShopOrderItemListResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
